/**
 * Quick mode: org-wide questions should not send page navigation scope to the API.
 */

const ORG_WIDE_PATTERNS = [
  /how many/i,
  /top \d/i,
  /contributors?/i,
  /repositories/i,
  /\bdora\b/i,
  /deployment frequency/i,
  /team health/i,
  /\bsummary\b/i,
  /active (devs?|contributors?|members?)/i,
  /commits? (this|last|past)/i,
  /prs? (merged|open|this|last)/i,
];

export function isQuickModeOrgWideMessage(message) {
  const msg = String(message || '').trim();
  if (!msg) return false;
  return ORG_WIDE_PATTERNS.some((p) => p.test(msg));
}
